export const selectLoginModalStep = (state) => state.ui.sellTickets.step;
export const selectUser = (state) => state.ui.sellTickets.user;
export const selectSellEvents = (state) => state.ui.sellTickets.events;
export const selectSellTickets = (state) => state.ui.sellTickets.tickets;
export const selectSellSelectedEvent = (state) => state.ui.sellTickets.event;
export const selectSellFormData = (state, form) => state.ui.sellTickets.forms[form];
export const selectHasMultipleEvents = (state) => state.ui.sellTickets.hasMultipleEvents;
